import { Box, Button, Container, Divider, Link, Stack, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchNachrichtenDetails } from '../../../../hooks/FetchNachrichten';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import { ArrowBack } from '@mui/icons-material';
import { get } from 'lodash';

import Schema from '../../../../lib/paths/portal45nachricht_DETAILS_SEITE_Paths.json';
import CreateNachricht from '../../../../components/ui-component/nachrichten/CreateNachricht';
import { APIS } from '../../../../lib/constants/apis';
import { DisplayDate } from '../../../../utils/formats';
const P = Schema.attributes;

const NachrichtenDetails: FC<{}> = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const numericId = id ? parseInt(id) : -1;

	const [openMessage, setOpenMessage] = useState(false);
	const { loading, data, error } = useFetchNachrichtenDetails(numericId);

	const RenderAppLink = () => {
		const antragID = get(data, `${P.Zuwendungsantrag.path}.id`);
		const maID = get(data, `${P.Mittelabruf.path}.id`);
		const vnID = get(data, `${P.Verwendungsnachweis.path}.id`);

		if (!maID && !vnID) {
			return (
				<Typography>
					Zuwendungsantrag{' '}
					<Link
						sx={{ cursor: 'pointer', textDecoration: 'unterlinde' }}
						onClick={() => {
							navigate(`/meine-antraege/online-antrag/${antragID}`, {
								state: { api: APIS.Zuwendungsantrag },
							});
						}}
					>
						{' '}
						{get(data, P.Zuwendungsantrag.schema.attributes.Allgemein_Projektnummer.path)}
						{' - '}
						{get(data, P.Zuwendungsantrag.schema.attributes.Allgemein_Projekttitel.path)}
					</Link>{' '}
				</Typography>
			);
		}
		if (maID) {
			return (
				<Typography>
					Mittelabruf{' '}
					<Link
						sx={{ cursor: 'pointer', textDecoration: 'unterlinde' }}
						onClick={() => {
							navigate(`/meine-antraege/online-antrag/${maID}`, {
								state: { api: APIS.Mittelabruf },
							});
						}}
					>
						{' '}
						{get(data, P.Mittelabruf.schema.attributes.Allgemein_Nr.path)}
						{' - '}
						{'Vom: ' + DisplayDate(get(data, P.Mittelabruf.schema.attributes.Allgemein_Abrufdatum.path, ''))}
					</Link>{' '}
				</Typography>
			);
		}

		if (vnID) {
			return (
				<Typography>
					Verwendungsnachweis{' '}
					<Link
						sx={{ cursor: 'pointer', textDecoration: 'unterlinde' }}
						onClick={() => {
							navigate(`/meine-antraege/online-antrag/${vnID}`, {
								state: { api: APIS.Verwendungsnachweis },
							});
						}}
					>
						{' '}
						{get(data, P.Verwendungsnachweis.schema.attributes.Allgemein_Nr.path)}
						{' - '}
						{'Vom: ' +
							DisplayDate(get(data, P.Verwendungsnachweis.schema.attributes.Allgemein_Verwendungsnachweis_Vom.path, ''))}
					</Link>{' '}
				</Typography>
			);
		}

		return <></>;
	};

	if (error) console.error(' error', error);
	if (loading) return <LoadingBackdrop />;

	return (
		<>
			<Container>
				<CreateNachricht
					showNachrichtDialog={openMessage}
					handleCloseDialog={() => setOpenMessage(false)}
					applications={[get(data, P.Zuwendungsantrag.path)]}
					isReply={true}
					nachrichtId={get(data, 'id')}
					originalTitle={get(data, P.Allgemein_Betreff.path)}
					originalContent={get(data, P.Allgemein_Inhalt.path)}
				/>
				<Stack spacing={3}>
					<Stack direction={'row'} justifyContent={'space-between'}>
						<Button variant={'outlined'} startIcon={<ArrowBack />} onClick={() => navigate('/meine-nachrichten')}>
							{' '}
							Zurück zu meinen Nachrichten
						</Button>
						{get(data, P.Allgemein_Ordner.path) === 'Posteingang' && (
							<Button onClick={() => setOpenMessage(true)}>Antworten</Button>
						)}
					</Stack>
					<Stack spacing={3}>
						{' '}
						<Typography variant="h3">{'Betreff: ' + get(data, P.Allgemein_Betreff.path)}</Typography>
						<Box>
							{get(data, P.Allgemein_Ordner.path) === 'Posteingang' ? (
								<Typography>Von: Fördermittelgeber </Typography>
							) : (
								<Typography>
									Von:{' '}
									{get(data, P.Antragstellende.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path)}{' '}
								</Typography>
							)}

							<RenderAppLink />
						</Box>
						<Divider />
						<Typography component={'div'}>
							<div dangerouslySetInnerHTML={{ __html: get(data, P.Allgemein_Inhalt.path) }}></div>
						</Typography>
					</Stack>
				</Stack>
			</Container>
		</>
	);
};
export default NachrichtenDetails;
